import { render } from "./PrivacyPolicy.vue?vue&type=template&id=a810a090&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "@/css/layerPop.scss?vue&type=style&index=0&id=a810a090&scoped=true&lang=scss"
import "./PrivacyPolicy.vue?vue&type=style&index=1&id=a810a090&lang=scss&scoped=true"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a810a090"]])

export default __exports__